import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ProfileInfo } from "../.././common/Info";
import { playerQuit } from "./playersSlice";

const initialState: ProfileInfo = {
  id: "",
  name: "",
  location: "",
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    login(state, action: PayloadAction<ProfileInfo>) {
      return action.payload;
    },
    youLoggedOut() {
      return initialState;
    },
    youQuit() {},
  },
  extraReducers(builder) {
    builder.addCase(playerQuit, (state) => {
      state.location = "lobby";
    });
  },
});

export const { login, youLoggedOut, youQuit } = profileSlice.actions;
export const profileReducer = profileSlice.reducer;
